import { useState } from "react";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
export default function HeroBanner() {
  const [disclosureOpen, setDisclosureOpen] = useState(false);
  return <section className="dark">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&family=DM+Sans:wght@400;500&display=swap');`}</style>
      <div className="bg-black text-white min-h-fit relative overflow-hidden">
        <div className="absolute top-0 left-0 w-64 h-64 opacity-[0.04]" style={{
        backgroundImage: "repeating-linear-gradient(0deg, transparent, transparent 40px, currentColor 40px, currentColor 41px), repeating-linear-gradient(90deg, transparent, transparent 40px, currentColor 40px, currentColor 41px)"
      }} />

        <div className="absolute top-0 left-0 w-[300px] h-[300px] rounded-lg bg-primary/5 blur-3xl -translate-x-1/2 -translate-y-1/2 pointer-events-none" />
        <div className="absolute bottom-0 right-0 w-[200px] h-[200px] rounded-lg bg-accent/10 blur-2xl translate-x-1/3 translate-y-1/3 pointer-events-none" />

        <div className="relative z-10 max-w-6xl mx-auto px-6 py-4 md:py-8 lg:py-12">
          <div className="flex flex-col lg:flex-row lg:items-start lg:gap-16">
            <div className="flex-1 order-2 lg:order-1">
              <div className="flex items-center gap-3 mb-6">
                <div className="h-px w-8 bg-background" />
                
              </div>

              <h1 className="leading-[1.05] tracking-tight mb-2 text-background text-3xl md:text-6xl font-bold md:mb-4"><br />Best Teeth Whitening Products Tested (2026):&nbsp;<span className="text-background font-bold" data-ast-id="f:/src/pages/Home/sections/HeroBanner.tsx|sig:bhb0c" data-ast-start="1703" data-ast-end="1906"><br />How One Product Beat Every Major Brand</span></h1>

              <Separator className="my-3 bg-border/40" />

              <div className="flex flex-wrap items-center gap-4">
                <Badge variant="outline" className="inline-flex items-center justify-center rounded-md border w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&]:hover:bg-accent [a&]:hover:text-accent-foreground border-border/50 px-3 py-1 text-xs font-medium text-background">Last Updated — May 28, 2026<br />By Emma Richardson</Badge>

                <button onClick={() => setDisclosureOpen(!disclosureOpen)} className="flex items-center gap-1.5 text-xs hover:text-foreground transition-colors duration-200 underline underline-offset-4 decoration-muted-foreground/40 hover:decoration-foreground/60 text-background">
                  <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <circle cx="12" cy="12" r="10" />
                    <path d="M12 16v-4M12 8h.01" />
                  </svg>
                  Editorial Disclosure
                </button>
              </div>

              {disclosureOpen && <div className="mt-4 relative bg-card border border-border/60 rounded-xl p-5 max-w-xl shadow-lg">
                  <button onClick={() => setDisclosureOpen(false)} className="absolute top-3 right-3 text-muted-foreground hover:text-foreground transition-colors" aria-label="Close">
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                  <p className="text-sm text-muted-foreground leading-relaxed pr-6" style={{
                fontFamily: "'DM Sans', sans-serif"
              }}>
                    We test and review products independently. If you click a link on our site and make a purchase, we may earn a small commission at no extra cost to you. Brands can't pay us to rank higher or change our ratings. Every opinion on this page is our own.
                  </p>
                </div>}
            </div>

            <div className="order-1 lg:order-2 flex-shrink-0 flex flex-col items-center lg:items-end justify-start pt-0 mb-4 lg:mb-0">
              <div className="relative group">
                <div className="absolute inset-0 rounded-2xl bg-primary/10 blur-xl scale-110 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                
              </div>
              
            </div>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-border to-transparent" />
      </div>
    </section>;
}